export const babylonLyrics = [
  { text: "You come and go as you please", start: 28.5, end: 31.15 },
  { text: "You won't achieve a thing with the company you keep", start: 31.15, end: 34.69 },
  { text: "May your", start: 34.69, end: 36.1 },
  { text: "Bloodline rest in peace", start: 36.1, end: 38.2 },
  { text: "By that I mean their mindset has always been deceased", start: 38.2, end: 42 },
  { text: "Ahem", start: 42, end: 42.3 },
  { text: "And by the look on your face I know your feelin it", start: 42.3, end: 45.5 },
  { text: "Sign after sign what I'm saying has been imminent", start: 45.5, end: 48.9 },
  { text: "So they just project all their fears onto you", start: 48.9, end: 52.6 },
  { text: "By keeping you comfortable is how they soothe their wounds", start: 52.6, end: 56.236 },
  { text: "Where ya going", start: 56.236, end: 58.5 },
  { text: "Me go high you go low", start: 58.5, end: 60.59 },
  { text: "Ya see me suffer down for work you lay down and tip toe", start: 60.59, end: 63.5 },
  { text: "Where ya going", start: 63.5, end: 65.44 },
  { text: "Me go high you go low", start: 65.44, end: 68 },
  { text: "Ya see me suffer down for work you lay down and tip toe", start: 68, end: 71 },
  { text: "Babylon slow down", start: 71, end: 73 },
  { text: "Doubt is a different penitentiary", start: 73, end: 74 },
  { text: "You live your life behind bars you've built mentally", start: 74, end: 78 },
  { text: "Your own mind has become your biggest enemy", start: 78, end: 81.76 },
  { text: "Foe, Foe", start: 81.76, end: 85.9 },
  { text: "But", start: 85.9, end: 86.3 },
  { text: "Who jah bless no man curse", start: 86.3, end: 88.53 },
  { text: "Connect to your heart they'll be no more time served", start: 88.53, end: 92 },
  { text: "Ya no work hard for your blessing", start: 92, end: 94.37 },
  { text: "Conviction desolate", start: 94.37, end: 95.5 },
  { text: "To your own back you continue to turn", start: 95.5, end: 99.68 },
  { text: "Slow down", start: 99.68, end: 101.17 },
  { text: "You say your wanna chase your dreams", start: 101.5, end: 105.1 },
  { text: "You are just a bird with the wind beneath your wings", start: 105.1, end: 108.57 },
  { text: "I bet", start: 108.57, end: 109 },
  { text: "Discipline you lack is what it seems", start: 109, end: 112 },
  { text: "You no harvest your fruit on the day you plant your seeds", start:.112 , end: 115.7 },
  { text: "I know the waters cold and you hesitate", start: 115.7, end: 119.90 },
  { text: "But it don't get no warmer if you jump in late ya see", start: 119.90, end: 123.6 },
  { text: "Fountains and fountains and fountains I bring you but no", start: 123.6, end: 127.39 },
  { text: "Replenishment was never your goal", start: 127.39, end: 129.79 },
  { text: "Babylon", start: 130, end: 131 },
  { text: "Where ya going", start: 131, end: 132 },
  { text: "Me go high you go low", start: 132, end: 134.5 },
  { text: "Ya see me suffer down for work you lay down and tip toe", start: 134.5, end: 138 },
  { text: "Where ya going", start: 138, end: 139.5 },
  { text: "Me go high you go low", start: 139.5, end: 141.76 },
  { text: "Ya see me suffer down for work you lay down and tip toe", start: 141.76, end: 144.5 },
  { text: "Babylon slow down", start: 144.5, end: 148.2 },
] as const satisfies ReadonlyArray<{ readonly text: string, readonly start?: number, readonly end?: number }>;
